/**
 * @author Nihar <nihar.baishya@314ecorp.com>
 * @description ViewBatchMapping
 */
import _ from 'lodash';
import { useMemo, useState } from 'react';
import { ColDef } from 'ag-grid-community';
import { Button as AntButton, ButtonProps, Modal, Segmented } from 'antd';

import { AgGridTable, TABLE_OFFSET } from 'lib/agGrid';
import useMetaData from 'hooks/useMetadata';
import { prepareBatchResponseTabs } from 'utils/eligibility/eligibilityBatchUpload';

/**
 * ViewBatchMapping
 *
 */
const ViewBatchMapping: React.FC<{ batchMeta: EligibilityBatchUpload.IBatchEligibilityResponseList } & ButtonProps> = ({
	batchMeta,
	...restProps
}) => {
	const metaData = useMetaData();
	const [visible, setVisible] = useState(false);
	const [activeTab, setActiveTab] = useState('Provider');
	const tabItems = useMemo(() => prepareBatchResponseTabs(batchMeta, metaData), [batchMeta, metaData]);

	const segmentedOptions = useMemo(() => _.keys(tabItems), [tabItems]);

	const activeTabContent = useMemo(() => _.get(tabItems, activeTab), [tabItems, activeTab]);

	const modalContent = (
		<>
			<Segmented
				data-testid='batch-mapping-tabs'
				options={segmentedOptions}
				value={activeTab}
				onChange={(value) => setActiveTab(value)}
				className='mb-2 gap-2'
			/>
			{activeTabContent && (
				<AgGridTable
					data-testid='batch-mapping-table'
					key='key'
					pagination={false}
					tableOffset={TABLE_OFFSET.smallTable}
					columnDefs={activeTabContent?.content?.columns as ColDef<AnyType>[]}
					rowData={activeTabContent?.content?.data}
				/>
			)}
		</>
	);

	return (
		<>
			<AntButton
				data-testid='batch-view-mapping-button'
				key='view-eligibility-batch-mapping'
				onClick={() => setVisible(true)}
				{...restProps}
			>
				{'View Mapping'}
			</AntButton>
			<Modal data-testid='batch-mapping-modal' footer={null} title='Mappings' open={visible} className='identifier-modal' onCancel={() => setVisible(false)}>
				{modalContent}
			</Modal>
		</>
	);
};

export default ViewBatchMapping;
